/* ============================================================
   UNREEL PROMPT VAULT — behaviour
   Search / filter / copy, and the unlock (paywall) layer.
   ============================================================ */
(function () {
  "use strict";

  var CFG = window.UNREEL_CONFIG || {};
  var COPY = window.UNREEL_QC_COPY || {};
  var ACCESS = CFG.access || {};
  var CAPTURE = CFG.capture || {};
  var KEY = ACCESS.storageKey || "unreel_vault_access";
  var SIGNUP_KEY = CAPTURE.storageKey || "unreel_vault_signup";

  /* ---------------------------------------------------- helpers */
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  var toastEl, toastTimer;
  function toast(msg, good) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.className = "toast show" + (good ? " good" : "");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.className = "toast"; }, 2600);
  }

  /* ---------------------------------------------------- access state */
  function isUnlocked() {
    /* CFG.isMember is rendered by Liquid from the customer's tag, so it is
       the authoritative answer. Without it the client re-locked cards that
       Shopify had already unlocked server-side, and every paying member saw
       a blurred vault. */
    if (ACCESS.mode === "shopify") return CFG.isMember === true;
    if (CFG.isMember === true) return true;
    try { return localStorage.getItem(KEY) === "granted"; } catch (e) { return false; }
  }

  function isRegistered() {
    // An existing customer has already supplied an email. Free access does
    // not enroll them in marketing or grant the members-only prompts.
    if (CFG.videoAuth && CFG.videoAuth.customerId && CFG.videoAuth.email) return true;
    try { return !!localStorage.getItem(SIGNUP_KEY); } catch (e) { return false; }
  }

  function grant(silent) {
    try { localStorage.setItem(KEY, "granted"); } catch (e) {}
    paint();
    if (!silent) toast("Vault unlocked — all " + $$("#grid .card").length + " prompts are live.", true);
  }
  function revoke() {
    try { localStorage.removeItem(KEY); } catch (e) {}
    paint();
    toast("Locked again — preview mode.");
  }

  /* Checksum codes: UNREEL-XXXXXX-CC.
     Lets you mint codes in bulk without redeploying the site.
     NOTE: in "client" mode the salt ships to the browser, so a determined
     visitor can forge a code. Switch access.mode to "server" for real
     enforcement (see serverless/verify-subscription.js). */
  function checksum(body) {
    var s = String(body) + "|" + (ACCESS.codeSalt || "");
    var h = 5381;
    for (var i = 0; i < s.length; i++) { h = ((h << 5) + h + s.charCodeAt(i)) >>> 0; }
    return ("0" + (h % 1296).toString(36)).slice(-2).toUpperCase();
  }
  function codeLooksValid(raw) {
    var code = String(raw || "").trim().toUpperCase();
    if (!code) return false;
    var statics = ACCESS.staticCodes || [];
    for (var i = 0; i < statics.length; i++) {
      if (statics[i].toUpperCase() === code) return true;
    }
    var parts = code.split("-");
    if (parts.length !== 3) return false;
    if (parts[0] !== String(ACCESS.codePrefix || "UNREEL").toUpperCase()) return false;
    return checksum(parts[1]) === parts[2];
  }

  function redeem(raw, inputEl) {
    var code = String(raw || "").trim().toUpperCase();
    if (!code) { toast("Enter your access code."); return; }

    if (ACCESS.mode === "server") {
      fetch(ACCESS.verifyEndpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ code: code })
      })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d && d.valid) { grant(); }
        else { fail(inputEl, "That code isn't an active membership."); }
      })
      .catch(function () { fail(inputEl, "Couldn't reach the server. Try again."); });
      return;
    }

    if (codeLooksValid(code)) { grant(); }
    else { fail(inputEl, "That code isn't valid."); }
  }

  function fail(inputEl, msg) {
    toast(msg);
    if (inputEl) {
      inputEl.classList.add("bad");
      setTimeout(function () { inputEl.classList.remove("bad"); }, 600);
    }
  }

  /* ---------------------------------------------------- paint lock state */
  function paint() {
    var open = isUnlocked();

    $$("#grid .card").forEach(function (card) {
      var free = card.getAttribute("data-free") === "1";
      // Only the free-flagged cards carry real text for non-members; the rest
      // hold decoy filler, so unblurring them would reveal nothing but filler.
      var readable = open || (free && (!CAPTURE.enabled || isRegistered()));
      card.classList.toggle("locked", !readable);
      card.classList.toggle("registered-unlock", !open && free && readable);
    });
    var badge = $("#status-badge");
    if (badge) {
      badge.classList.toggle("is-unlocked", open);
      badge.querySelector("span.txt").textContent = open ? "Member" : "Preview";
    }
    $$("[data-when-locked]").forEach(function (el) { el.style.display = open ? "none" : ""; });
    $$("[data-when-unlocked]").forEach(function (el) { el.style.display = open ? "" : "none"; });
    $$("[data-when-anon]").forEach(function (el) {
      el.style.display = (!open && !isRegistered() && CAPTURE.enabled) ? "" : "none";
    });
    $$("[data-when-registered]").forEach(function (el) {
      el.style.display = (!open && isRegistered() && CAPTURE.enabled) ? "" : "none";
    });
  }

  /* ------------------------------------------------- signup (email capture) */
  function submitSignup(email, firstName, formEl) {
    var payload = {
      email: email,
      first_name: firstName || "",
      source: "prompt-vault",
      signed_up_at: new Date().toISOString()
    };

    function accept() {
      try { localStorage.setItem(SIGNUP_KEY, JSON.stringify(payload)); } catch (e) {}
      paint();
      closeModal();
      toast("Unlocked " + (CAPTURE.registeredUnlocks || 0) +
            " prompts \u2014 yours to keep. Unlock all 100 anytime.", true);
    }

    var btn = formEl && formEl.querySelector("button");
    if (btn) { btn.disabled = true; btn.textContent = "Sending…"; }

    // Post to Shopify's own customer form. No third-party service, no API key:
    // the signup becomes a real customer record, so buyers later match to the
    // same email automatically instead of living in a separate list.
    var body = new FormData();
    body.append("form_type", "customer");
    body.append("utf8", "\u2713");
    body.append("contact[email]", email);
    if (firstName) body.append("contact[first_name]", firstName);
    body.append("contact[tags]", "prompt-vault-signup");
    body.append("contact[accepts_marketing]", "true");

    fetch(CAPTURE.endpoint || "/contact", { method: "POST", body: body })
      .then(function (r) {
        // Shopify answers 200 with the rendered page, or 302. Either is fine;
        // a hard network failure is the only real error here.
        accept();
      })
      .catch(function () {
        toast("Could not sign you up just now. Try again in a moment.");
      })
      .finally(function () {
        if (btn) { btn.disabled = false; btn.textContent = "Get free prompts"; }
      });
  }

  /* ---------------------------------------------------- checkout */
  function checkoutUrl() {
    var s = CFG.shopify || {};
    if (!s.variantId) return null;
    // On the Shopify storefront itself a relative permalink is correct and
    // safer - it keeps the customer on the domain they are already browsing.
    // shopDomain is only needed when the page is hosted somewhere else.
    var url;
    if (s.shopDomain) {
      var domain = s.shopDomain.replace(/^https?:\/\//, "").replace(/\/+$/, "");
      url = "https://" + domain + "/cart/" + s.variantId + ":1";
    } else {
      url = "/cart/" + s.variantId + ":1";
    }
    var q = [];
    if (s.sellingPlanId) q.push("selling_plan=" + encodeURIComponent(s.sellingPlanId));
    if (s.returnUrl) q.push("return_to=" + encodeURIComponent("/checkout"));
    return q.length ? url + "?" + q.join("&") : url;
  }

  // Preserve the cart and reconcile a repeated click before adding anything.
  var checkoutBusy = false;
  async function checkoutLine(line, event) {
    if (event) event.preventDefault();
    if (checkoutBusy) return;
    checkoutBusy = true;
    var target = event && event.currentTarget;
    var button = target && (target.tagName === "FORM" ? target.querySelector('button[type="submit"]') : target);
    var label = button && button.textContent;
    if (button) {button.disabled = true;button.textContent = COPY.opening_checkout;}
    var headers = {"Content-Type":"application/json"};
    try {
      var response = await fetch('/cart.js', {credentials:'same-origin'});
      if (!response.ok) throw new Error('cart');
      var cart = await response.json();
      var existing = cart.items.find(function(item) {
        return String(item.variant_id) === String(line.id) &&
          String(item.selling_plan_allocation && item.selling_plan_allocation.selling_plan.id || '') === String(line.selling_plan || '');
      });
      var options = {method:'POST', headers:headers, credentials:'same-origin'};
      if (existing) {
        options.body = JSON.stringify({id:existing.key,quantity:line.selling_plan?1:existing.quantity});
        response = await fetch('/cart/change.js', options);
      } else {
        options.body = JSON.stringify({items:[line]});
        response = await fetch('/cart/add.js', options);
      }
      if (!response.ok) throw new Error('cart update');
      window.location.href = '/checkout';
    } catch (_) {
      toast(COPY.checkout_error);
      if (target && !target.querySelector('.qc-check-cart')) {
        var link = document.createElement('a');link.className='btn qc-check-cart';link.href='/cart';link.textContent=COPY.view_cart;
        target.tagName==='FORM'?target.appendChild(link):target.insertAdjacentElement('afterend',link);
      }
    } finally {
      checkoutBusy=false;if(button){button.disabled=false;button.textContent=label;}
    }
  }
  function buyNow(event) {
    if(event)event.preventDefault();
    var s=CFG.shopify||{};
    if(!s.variantId||!s.sellingPlanId){toast(COPY.membership_unavailable);return;}
    return checkoutLine({id:Number(s.variantId),quantity:1,selling_plan:Number(s.sellingPlanId)},event);
  }

  /* On phones the nav has no room for a Log in link, so pressing Unlock
     offers the choice instead: continue to checkout, or log in. Desktop keeps
     the one-tap path - its nav already carries Log in. The sheet is built on
     first use; the login URL is read off the nav's (hidden) auth link so
     Liquid stays the single source of truth for where login lives. */
  var unlockSheet = null;
  function buildUnlockSheet() {
    if (unlockSheet) return unlockSheet;
    var auth = document.querySelector("a.nav-auth");
    var d = document.createElement("div");
    d.className = "unlock-sheet";
    d.innerHTML =
      '<div class="us-backdrop"></div>' +
      '<div class="us-panel" role="dialog" aria-modal="true" aria-label="Unlock the vault">' +
      '<h3>Unlock the vault</h3>' +
      '<p>Every prompt, the builder, and 20 new prompts on the 1st of every month.</p>' +
      '<button type="button" class="btn btn-primary btn-lg" data-us-checkout>' +
      'Continue to checkout &middot; $12/mo</button>' +
      (auth ? '<a class="us-login" href="' + auth.href + '">Already a member? Log in</a>' : '') +
      '<button type="button" class="us-cancel">Not now</button></div>';
    document.body.appendChild(d);
    d.querySelector(".us-backdrop").addEventListener("click", closeUnlockSheet);
    d.querySelector(".us-cancel").addEventListener("click", closeUnlockSheet);
    d.querySelector("[data-us-checkout]").addEventListener("click", function () {
      closeUnlockSheet();
      buyNow();
    });
    unlockSheet = d;
    return d;
  }
  function openUnlockSheet() {
    buildUnlockSheet().classList.add("open");
    document.body.style.overflow = "hidden";
  }
  function closeUnlockSheet() {
    if (unlockSheet) {
      unlockSheet.classList.remove("open");
      document.body.style.overflow = "";
    }
  }
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeUnlockSheet();
  });
  function buyOrSheet(e) {
    if(e)e.preventDefault();
    window.location.href='/#pricing';
  }
  function startCheckout(){buyNow();}

  /* ---------------------------------------------------- modal */
  var modal, _modalReturn = null;
  function modalFocusables() {
    return modal ? Array.prototype.slice.call(
      modal.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])'))
      .filter(function (el) { return el.offsetParent !== null; }) : [];
  }
  function openModal(reason) {
    if (!modal) return;
    _modalReturn = document.activeElement;
    modal.classList.add("open");
    modal.setAttribute("data-reason", reason || "unlock");
    document.body.style.overflow = "hidden";
    var f = modalFocusables();
    if (f.length) f[0].focus();
  }
  function closeModal() {
    if (modal) {
      modal.classList.remove("open");
      document.body.style.overflow = "";
      if (_modalReturn && _modalReturn.focus) _modalReturn.focus();
    }
  }

  /* ---------------------------------------------------- search + filter */
  var activeCat = "All";
  /* keep aria-pressed in lockstep with the .active class on filter chips so
     screen-reader users hear which category is selected */
  function syncChipPressed() {
    $$(".filters button").forEach(function (x) {
      x.setAttribute("aria-pressed", x.classList.contains("active") ? "true" : "false");
    });
  }
  var query = "";

  function applyFilter() {
    var shown = 0;
    $$("#grid .card").forEach(function (card) {
      var cat = card.getAttribute("data-group");
      var hay = card.getAttribute("data-search") || "";
      var okCat = activeCat === "All" || cat === activeCat ||
                  (activeCat === "__favs" && favHas(card.id));
      if (activeCat === "__favs" && !favHas(card.id)) okCat = false;
      var okQ = !query || hay.indexOf(query) !== -1;
      var show = okCat && okQ;
      card.style.display = show ? "" : "none";
      if (show) shown++;
    });
    var line = $("#result-line");
    if (line) {
      var where = activeCat === "__favs" ? " in your favorites"
        : (activeCat !== "All" ? " in " + activeCat : "");
      line.textContent = (activeCat === "__favs" && !shown && !query)
        ? "No favorites yet \u2014 tap the \u2665 on any prompt to save it here"
        : shown + (shown === 1 ? " prompt" : " prompts") + where +
          (query ? ' matching "' + query + '"' : "");
    }
    var empty = $("#empty");
    if (empty) empty.style.display = shown ? "none" : "";
  }

  /* ---------------------------------------------------- boot */
  /* The filter bar sticks directly under the nav. The nav's height changes
     with viewport width, so measure it instead of hardcoding an offset. */
  function syncNavHeight() {
    var nav = $(".nav");
    if (!nav) return;
    var h = Math.round(nav.getBoundingClientRect().height);
    document.documentElement.style.setProperty("--nav-h", h + "px");
  }

  document.addEventListener("DOMContentLoaded", function () {
    toastEl = $("#toast");
    modal = $("#unlock-modal");
    document.addEventListener('unreel:access-required',function(){openModal();});
    if (modal) {
      modal.addEventListener("keydown", function (e) {
        if (e.key !== "Tab") return;
        var f = modalFocusables();
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });
    }

    /* ---------------------------------------------------- vault intro

       Whether to show it was decided by the inline gate in <head>, before the
       first paint. All that is left here is opening it. */
    (function () {
      var root = document.documentElement;
      if (!root.classList.contains("vault-locked")) return;
      var door = $("#vault-door");
      if (!door) { root.classList.remove("vault-locked"); return; }

      var opened = false;
      function open() {
        if (opened) return;
        opened = true;
        // The hero backdrop waits on this: film starts as the slabs part.
        try { window.dispatchEvent(new CustomEvent("vault:open")); } catch (e) {}
        door.classList.add("opening");
        // Keep the door displayed through the animation, then release the page.
        setTimeout(function () {
          root.classList.remove("vault-locked");
          if (door.parentNode) door.parentNode.removeChild(door);
        }, 1300);
      }
      var btn = $("#vault-open");
      if (btn) btn.addEventListener("click", open);
      door.addEventListener("click", open);
      document.addEventListener("keydown", function (e) {
        if (!opened && (e.key === "Enter" || e.key === " " || e.key === "Escape")) open();
      });
      // Never trap anyone: if the click never lands, it opens itself.
      setTimeout(open, 8000);
    })();

    /* On a phone the pinned toolbar costs half the viewport, so it collapses
       to just the search field while you scroll down through the grid, and
       comes back the moment you scroll up. Desktop keeps it fully expanded. */
    (function () {
      var controls = $(".controls");
      if (!controls) return;
      var lastY = window.pageYOffset, ticking = false;
      var isPhone = function () {
        // Same breakpoint the stylesheet uses, so the two can never disagree.
        return window.matchMedia("(max-width: 600px)").matches;
      };
      function update() {
        var y = window.pageYOffset;
        if (isPhone()) {
          if (y > lastY + 4 && y > 240) controls.classList.add("condensed");
          else if (y < lastY - 4) controls.classList.remove("condensed");
        } else {
          controls.classList.remove("condensed");
        }
        lastY = y;
        ticking = false;
      }
      // A timer rather than requestAnimationFrame: rAF is deferred entirely in
      // background tabs, which left the toolbar stuck expanded on wake.
      window.addEventListener("scroll", function () {
        if (ticking) return;
        ticking = true;
        setTimeout(update, 60);
      }, { passive: true });
      // A filter or search tap should always show the full set of options.
      controls.addEventListener("focusin", function () { controls.classList.remove("condensed"); });
    })();

    /* ---------------------------------------------------- next drop clock

       Prompts land on the 1st of every month. A fixed calendar date beats a
       rolling window: subscribers can diarise it, and it never drifts. The
       clock derives the date itself, so it keeps running years out with
       nothing to maintain. Local time, so it matches the visitor's calendar. */
    (function () {
      var el = $("#drop-countdown");
      if (!el) return;
      var out = el.querySelector(".cd-text");
      if (!out) return;

      var arc = el.querySelector(".lr-arc");
      var num = el.querySelector(".lr-num");
      var CIRC = 119.4;
      function render() {
        var now = new Date();
        var dropToday = now.getDate() === 1;
        // new Date(y, m + 1, 1) rolls December into January on its own.
        var next = new Date(now.getFullYear(), now.getMonth() + 1, 1, 0, 0, 0, 0);
        var left = next - now;
        var d = Math.floor(left / 86400000);
        var h = Math.floor(left % 86400000 / 3600000);
        var m = Math.floor(left % 3600000 / 60000);
        var s2 = Math.floor(left % 60000 / 1000);
        function pad(n) { return n < 10 ? "0" + n : String(n); }
        if (dropToday) {
          out.textContent = "New prompts dropping today";
        } else if (d === 0) {
          // drop day approaching: the days group falls away, hours lead
          out.textContent = "New prompts in " + pad(h) + ":" + pad(m) + ":" + pad(s2);
        } else {
          out.textContent = "New prompts in " + d + ":" + pad(h) + ":" + pad(m) + ":" + pad(s2);
        }
        // Academy leader ring: numeral carries days (hours on drop day),
        // the arc sweeps once per minute like a film leader.
        if (num) num.textContent = d > 0 ? d : h;
        if (arc) arc.style.strokeDashoffset = String(CIRC * (1 - s2 / 60));
        el.setAttribute("datetime", next.toISOString());
      }
      render();
      // WCAG 2.2.2: don't run a per-second ticking animation for visitors who
      // asked for reduced motion. Render a calmer minute-cadence (no sweeping
      // arc) instead of a static string, so the countdown still updates.
      var cdReduce = window.matchMedia &&
          window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      try { if (localStorage.getItem("unreel_motion") === "off") cdReduce = true; } catch (e) {}
      if (cdReduce) {
        if (arc) arc.style.display = "none";
        setInterval(render, 60000);
      } else {
        setInterval(render, 1000);
      }
    })();

    /* ---------------------------------------------------- hero backdrop

       One darkened clip behind the title card. The src is only ever set when
       the visitor has not asked for reduced motion; a refused play() simply
       leaves the graded poster frame showing. Paused whenever the hero is
       off screen so it never competes with the grid for decode budget. */
    (function () {
      var v = $(".hero-bg");
      if (!v) return;
      var wantsMotion = !window.matchMedia ||
        window.matchMedia("(prefers-reduced-motion: no-preference)").matches;
      if (!wantsMotion) return;                  // poster only, src never set
      var src = v.getAttribute("data-bg");
      if (!src) return;
      v.setAttribute("src", src);
      v.muted = true; v.playsInline = true;
      var started = false;
      function begin() {
        if (started) return;
        started = true;
        try { v.currentTime = 0; } catch (e) {}
        var p = v.play();
        if (p && p.catch) p.catch(function () { /* poster stays */ });
      }
      // Behind a closed vault door the film holds on frame one, so the doors
      // part exactly onto its opening moment. No door (returning visitor,
      // deep link): start immediately.
      if (document.documentElement.classList.contains("vault-locked")) {
        v.pause();
        window.addEventListener("vault:open", begin, { once: true });
        setTimeout(begin, 11000);              // failsafe mirrors the door's own
      } else {
        begin();
      }
      /* iOS pauses the film when the app is backgrounded, and the observer
         below never refires for an element that did not change intersection -
         the same eviction bug the card videos had. Revive on every return. */
      function reviveHero() {
        if (!started || !v.paused) return;
        var r = v.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;
        if (r.bottom > 0 && r.top < vh) {
          var q = v.play();
          if (q && q.catch) q.catch(function () {});
        }
      }
      document.addEventListener("visibilitychange", function () {
        if (!document.hidden) reviveHero();
      });
      window.addEventListener("pageshow", reviveHero);
      window.addEventListener("focus", reviveHero);
      if (window.IntersectionObserver) {
        new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            if (!started) return;              // never let the observer pre-empt the door
            if (e.isIntersecting) { var q = v.play(); if (q && q.catch) q.catch(function(){}); }
            else { v.pause(); }
          });
        }, { threshold: 0 }).observe(v);
      }
    })();

    function openLinkedPrompt(){
      var id=window.location.hash.slice(1);
      if(!/^p[0-9]{3}$/.test(id))return;
      var target=document.getElementById(id),search=document.getElementById('search');
      if(!target||!target.matches('#grid .card')||!search)return;
      var title=target.querySelector('h2');if(!title)return;
      search.value=title.textContent.trim();query=search.value.toLowerCase();activeCat='All';applyFilter();
      setTimeout(function(){target.scrollIntoView({block:'center'});},0);
    }
    window.addEventListener('hashchange',openLinkedPrompt);
    openLinkedPrompt();

    syncNavHeight();
    window.addEventListener("resize", syncNavHeight);
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(syncNavHeight);
      if ($(".nav")) ro.observe($(".nav"));
    }

    /* Returning from Shopify checkout: ?unlocked=1 or ?code=XXXX */
    var params = new URLSearchParams(window.location.search);
    if (ACCESS.mode !== "shopify" && params.get("unlocked") === "1") {
      grant(true);
      toast("Payment confirmed — vault unlocked.", true);
      history.replaceState({}, "", window.location.pathname);
    } else if (ACCESS.mode !== "shopify" && params.get("code")) {
      redeem(params.get("code"));
      history.replaceState({}, "", window.location.pathname);
    }

    /* content-visibility gives off-screen cards ESTIMATED heights, so a jump
       to an anchor below the grid (e.g. #pricing) lands short, then drifts as
       real heights resolve. Intercept same-page hash links and keep re-aiming
       until the target stops moving. */
    (function () {
      function settle(el) {
        var tries = 0;
        function aim() {
          var want = parseInt(getComputedStyle(el).scrollMarginTop, 10) || 0;
          var off = el.getBoundingClientRect().top - want;
          if (Math.abs(off) > 4 && tries++ < 8) {
            window.scrollTo({ top: window.scrollY + off, behavior: "instant" });
            setTimeout(aim, 180);
          }
        }
        el.scrollIntoView();
        setTimeout(aim, 220);
      }
      $$("a[href*='#']").forEach(function (a) {
        if (a.hasAttribute("data-action") || a.hasAttribute("data-key-open")) return;
        a.addEventListener("click", function (e) {
          var href = a.getAttribute("href") || "";
          var i = href.indexOf("#");
          if (i < 0) return;
          var before = href.slice(0, i);
          var path = before.split("?")[0];
          if (path && path !== window.location.pathname &&
              !(path === "/" && window.location.pathname === "/")) return;
          var el = document.getElementById(href.slice(i + 1));
          if (!el) return;
          /* category deep-links (?cat=X#vault) from the nav dropdown: apply
             the filter client-side instead of swallowing the query - the
             original interceptor scrolled but silently dropped the category */
          var q = before.indexOf("?") > -1 ? before.slice(before.indexOf("?") + 1) : "";
          var cat = q ? new URLSearchParams(q).get("cat") : null;
          if (cat) {
            var chip = $$(".filters button").filter(function (b) {
              return b.getAttribute("data-filter") === cat;
            })[0];
            if (!chip) return;               // unknown category: full navigation
            e.preventDefault();
            chip.click();
            try { history.replaceState(null, "", window.location.pathname + "?cat=" + encodeURIComponent(cat) + "#" + href.slice(i + 1)); } catch (err) {}
            settle(el);
            return;
          }
          e.preventDefault();
          try { history.pushState(null, "", "#" + href.slice(i + 1)); } catch (err) {}
          settle(el);
        });
      });
    })();

    /* Floating Builder button: once someone is deep in the grid, the nav is
       long gone - this keeps the members' tool one tap away on every page
       except the builder itself. */
    (function () {
      if (document.getElementById("builder-tool") ||
          document.querySelector(".builder-lock")) return;
      var navLink = $$(".nav-links a").filter(function (x) {
        return /builder/i.test(x.getAttribute("href") || "");
      })[0];
      var fab = document.createElement("a");
      fab.className = "builder-fab";
      fab.href = navLink ? navLink.getAttribute("href") : "/pages/builder";
      fab.setAttribute("aria-label", "Open the Prompt Builder");
      fab.innerHTML =
        '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
        'stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">' +
        '<path d="M12 3v3M12 18v3M3 12h3M18 12h3M5.6 5.6l2.1 2.1M16.3 16.3l2.1 2.1M18.4 5.6l-2.1 2.1M7.7 16.3l-2.1 2.1"/>' +
        '</svg><span>Builder</span>';
      document.body.appendChild(fab);
      function judge() {
        fab.classList.toggle("show", window.scrollY > 420);
      }
      /* plain toggle, no rAF gate: classList writes are cheap, and rAF is
         throttled to a standstill in background tabs and hidden panes */
      window.addEventListener("scroll", judge, { passive: true });
      judge();
    })();

    /* Favorites: a heart on every card, saved on this device, surfaced as a
       pseudo-category so it appears in the chip row AND the dropdown for free. */
    var FAVKEY = "unreel_favs";
    function favList() {
      try { return JSON.parse(localStorage.getItem(FAVKEY) || "[]"); } catch (e) { return []; }
    }
    function favHas(id) { return favList().indexOf(id) > -1; }
    window.favHas = favHas;
    (function () {
      var cards = $$("#grid .card");
      if (!cards.length) return;

      function savefav(list) {
        try { localStorage.setItem(FAVKEY, JSON.stringify(list)); } catch (e) {}
      }
      function paintFavCount() {
        var n = favList().length;
        /* the chip AND its clone inside the category dropdown */
        $$("[data-filter='__favs'] small").forEach(function (el) {
          el.textContent = n;
        });
      }

      /* the chip - inserted right after "All" so both the row and the
         dropdown (built from these chips) pick it up */
      var all = $(".filters button[data-filter='All']");
      if (all) {
        var chip = document.createElement("button");
        chip.type = "button";
        chip.setAttribute("data-filter", "__favs");
        chip.setAttribute("aria-pressed", "false");
        chip.innerHTML = "\u2665 Favorites <small>" + favList().length + "</small>";
        all.parentNode.insertBefore(chip, all.nextSibling);
        // the generic .filters-button click handler (bound later) covers this
        // chip too, including the aria-pressed sync; no separate handler here.
      }

      cards.forEach(function (card) {
        var media = card.querySelector(".media-wrap");
        if (!media) return;
        var b = document.createElement("button");
        b.type = "button";
        b.className = "fav-btn" + (favHas(card.id) ? " on" : "");
        b.setAttribute("aria-label", "Save to favorites");
        b.setAttribute("aria-pressed", favHas(card.id) ? "true" : "false");
        b.innerHTML = '<svg width="15" height="15" viewBox="0 0 24 24" ' +
          'stroke="currentColor" stroke-width="2" stroke-linejoin="round" ' +
          'fill="none"><path d="M12 21s-7.5-4.9-9.8-9.1C.7 9 2 5.6 5.2 5.1c1.9-.3 3.8.6 4.8 2.2h4c1-1.6 2.9-2.5 4.8-2.2 3.2.5 4.5 3.9 3 6.8C19.5 16.1 12 21 12 21z"/></svg>';
        b.addEventListener("click", function (e) {
          e.preventDefault(); e.stopPropagation();
          var list = favList();
          var i = list.indexOf(card.id);
          if (i > -1) list.splice(i, 1); else list.push(card.id);
          savefav(list);
          b.classList.toggle("on", i === -1);
          b.setAttribute("aria-pressed", i === -1 ? "true" : "false");
          paintFavCount();
          if (activeCat === "__favs") applyFilter();
        });
        media.appendChild(b);
      });
    })();

    /* Compact category dropdown (phones): one button instead of a chip row.
       It is built FROM the chip buttons so there is a single source of truth -
       picking an item clicks the matching chip and all logic stays in one
       place. CSS swaps which control is visible per breakpoint. */
    (function () {
      var chips = $$(".filters button");
      var filtersEl = $(".filters");
      if (!chips.length || !filtersEl || $(".cat-drop")) return;
      var wrap = document.createElement("div");
      wrap.className = "cat-drop";
      var btn = document.createElement("button");
      btn.type = "button"; btn.className = "cat-drop-btn";
      var panel = document.createElement("div");
      panel.className = "cat-drop-panel";
      function label() {
        var active = $(".filters button.active") || chips[0];
        btn.innerHTML = active.innerHTML +
          '<svg class="cd-caret" width="10" height="10" viewBox="0 0 24 24" fill="none" ' +
          'stroke="currentColor" stroke-width="3" stroke-linecap="round"><path d="M6 9l6 6 6-6"/></svg>';
      }
      chips.forEach(function (chip) {
        var item = document.createElement("button");
        item.type = "button";
        item.setAttribute("data-filter", chip.getAttribute("data-filter") || "");
        item.innerHTML = chip.innerHTML;
        item.addEventListener("click", function () {
          chip.click();
          label();
          wrap.classList.remove("open"); btn.setAttribute("aria-expanded", "false");
        });
        panel.appendChild(item);
      });
      btn.setAttribute("aria-controls", "vault-category-options");
      panel.id = "vault-category-options";
      btn.setAttribute("aria-expanded", "false");
      btn.addEventListener("click", function () {
        var open = wrap.classList.toggle("open");
        btn.setAttribute("aria-expanded", open ? "true" : "false");
      });
      document.addEventListener("click", function (e) {
        if (!wrap.contains(e.target)) { wrap.classList.remove("open"); btn.setAttribute("aria-expanded", "false"); }
      });
      wrap.addEventListener("keydown",function(event){if(event.key==="Escape"){wrap.classList.remove("open");btn.setAttribute("aria-expanded","false");btn.focus();}});
      chips.forEach(function (chip) { chip.addEventListener("click", function(){setTimeout(label,0)}); });
      label();
      wrap.appendChild(btn); wrap.appendChild(panel);
      var searchRow = $(".search-row");
      if (searchRow) searchRow.insertBefore(wrap, searchRow.firstChild);
      else filtersEl.parentNode.insertBefore(wrap, filtersEl);
    })();

    /* nav dropdown lands here with ?cat=Category#vault - apply that filter */
    try {
      var wantCat = new URLSearchParams(window.location.search).get("cat");
      if (wantCat) {
        var target = $$(".filters button").filter(function (b) {
          return (b.getAttribute("data-filter") || "") === wantCat;
        })[0];
        if (target) {
          $$(".filters button").forEach(function (x) { x.classList.remove("active"); });
          target.classList.add("active");
          syncChipPressed();
          activeCat = wantCat;
          if (target.scrollIntoView) target.scrollIntoView({ inline: "center", block: "nearest" });
        }
      }
    } catch (e) {}

    var search = $("#search");
    // Keep text entered while deferred scripts were loading.
    if (search) query = search.value.toLowerCase().trim();
    paint();
    applyFilter();

    /* search */
    if (search) {
      search.addEventListener("input", function () {
        query = this.value.toLowerCase().trim();
        applyFilter();
      });
    }
    var clearSearch = $("#clear-search");
    if (clearSearch) clearSearch.addEventListener("click", function () {
      query = ""; activeCat = "All";
      if (search) search.value = "";
      $$(".filters button").forEach(function (button) { button.classList.toggle("active", button.getAttribute("data-filter") === "All"); });
      syncChipPressed(); applyFilter();
      if (search) search.focus();
    });

    /* category filters */
    $$(".filters button").forEach(function (b) {
      b.addEventListener("click", function () {
        $$(".filters button").forEach(function (x) { x.classList.remove("active"); });
        b.classList.add("active");
        syncChipPressed();
        activeCat = b.getAttribute("data-filter");
        applyFilter();
      });
    });

    /* copy prompt.
       The Shopify build reads the text out of the <pre> rather than repeating
       it in a data-copy attribute, because duplicating 90 prompts pushed the
       Liquid template past Shopify's 256 KB per-file limit. */
    function copyClick() {
        var btn = this;
        var card = btn.closest(".card");
        if (card && card.classList.contains("locked")) { openModal(); return; }
        // Reading a free prompt is open; taking it costs an email. That is the
        // moment someone has decided it is useful, which is when they will pay
        // the small price of an address.
        if (CAPTURE.enabled && !isRegistered() && !isUnlocked()) {
          openModal("copy");
          return;
        }
        var pre = card && card.querySelector(".prompt pre");
        var text = btn.getAttribute("data-copy") || (pre ? pre.textContent : "");
        var done = function () {
          var old = btn.textContent;
          btn.textContent = "Copied";
          btn.classList.add("copied");
          setTimeout(function () { btn.textContent = old; btn.classList.remove("copied"); }, 1500);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(text).then(done, function () { legacyCopy(text); done(); });
        } else { legacyCopy(text); done(); }
    }
    $$("[data-copy],[data-copy-from-pre]").forEach(function (btn) {
      btn.addEventListener("click", copyClick);
    });

    /* ------------------------------------------------ member sign-in
       Shopify's hosted customer accounts never give the online store a
       session, so the theme cannot tell a member from a stranger. The
       membership API (server/) settles it instead: the member proves who
       they are, gets a signed token, and the API returns the prompt text.
       No prompt ships in this page at all.

       If no API URL is configured the older encrypted-bundle path still
       works, so publishing the theme before the Worker is deployed does
       not lock anyone out. */
    (function () {
      var API = String(CFG.memberApi || "").replace(/\/+$/, "");
      var MK = CFG.memberKey;
      /* No API configured means Shopify's own customer accounts are doing the
         work, and the nav link should behave as an ordinary login link. */
      if (!API) return;

      var TOKEN_KEY = "unreel_member_token";
      var LEGACY_KEY = "unreel_member_key";

      /* ---------------- apply unlocked content to the page ---------------- */
      function applyContent(prompts, builder) {
        try { localStorage.setItem(KEY, "granted"); } catch (e) {}

        if (prompts) {
          $$("pre[data-enc-pending]").forEach(function (pre) {
            var card = pre.closest(".card");
            var text = card && prompts[card.id];
            if (!text) return;
            pre.textContent = text;
            pre.removeAttribute("aria-hidden");
            pre.removeAttribute("data-enc-pending");
          });
        }
        $$(".card .lock-veil").forEach(function (v) {
          if (!v.classList.contains("free-veil")) v.remove();
        });
        $$("button[data-locked]").forEach(function (btn) {
          btn.removeAttribute("data-locked");
          btn.setAttribute("data-copy-from-pre", "");
          btn.addEventListener("click", copyClick);
        });
        var nb = $(".nav .badge-status");
        if (nb) {
          nb.classList.add("is-unlocked");
          var t = nb.querySelector(".txt");
          if (t) t.textContent = "Member";
        }
        $$("[data-action='buy']").forEach(function (b) { b.style.display = "none"; });
        $$("a.nav-auth--login").forEach(function (a) { a.style.display = "none"; });

        paint();
      }

      /* ---------------- membership API ---------------- */
      function api(path, opts) {
        return fetch(API + path, opts).then(function (r) {
          return r.json().catch(function () { return {}; }).then(function (body) {
            if (!r.ok) throw new Error(body.error || "Something went wrong. Try again.");
            return body;
          });
        });
      }
      function post(path, payload, token) {
        var headers = { "Content-Type": "application/json" };
        if (token) headers.Authorization = "Bearer " + token;
        return api(path, { method: "POST", headers: headers, body: JSON.stringify(payload) });
      }
      function loadVault(token) {
        return api("/vault", { headers: { Authorization: "Bearer " + token } })
          .then(function (data) { applyContent(data.prompts, data.builder); return true; });
      }

      /* ---------------- legacy access-key path ---------------- */
      function b64bytes(b64) {
        var bin = atob(b64), a = new Uint8Array(bin.length);
        for (var i = 0; i < bin.length; i++) a[i] = bin.charCodeAt(i);
        return a;
      }
      function deriveKey(code) {
        var e = new TextEncoder();
        return crypto.subtle.importKey("raw", e.encode(code), "PBKDF2", false, ["deriveKey"])
          .then(function (base) {
            return crypto.subtle.deriveKey(
              { name: "PBKDF2", salt: e.encode(MK.salt), iterations: MK.iters, hash: "SHA-256" },
              base, { name: "AES-GCM", length: 256 }, false, ["decrypt"]);
          });
      }
      function decrypt(key, blob) {
        var raw = b64bytes(blob);
        return crypto.subtle.decrypt({ name: "AES-GCM", iv: raw.slice(0, 12) }, key, raw.slice(12))
          .then(function (buf) { return new TextDecoder().decode(buf); });
      }
      function legacyUnlock(code) {
        return deriveKey(code).then(function (key) {
          return decrypt(key, MK.sentinel).then(function (t) {
            if (t !== "VAULT-OK") throw new Error("bad key");
            return fetch(MK.encUrl).then(function (r) { return r.json(); }).then(function (bundle) {
              var prompts = {}, jobs = [];
              Object.keys(bundle.prompts || {}).forEach(function (id) {
                jobs.push(decrypt(key, bundle.prompts[id]).then(function (txt) { prompts[id] = txt; }));
              });
              var builder = null;
              if (bundle.builder) {
                jobs.push(decrypt(key, bundle.builder).then(function (j) { builder = JSON.parse(j); }));
              }
              return Promise.all(jobs).then(function () { applyContent(prompts, builder); return true; });
            });
          });
        });
      }

      /* ---------------- sign-in modal ---------------- */
      var mm = null, step = "email", email = "", method = "order";

      function fields() {
        if (API && step === "email") {
          return '<p class="note">Enter the email you subscribed with.</p>' +
            '<form class="redeem-form" data-member-form>' +
            '<input type="email" name="v" placeholder="you@example.com" autocomplete="email" required>' +
            '<button class="btn btn-primary" type="submit">Continue</button></form>';
        }
        if (API && method === "code") {
          return '<p class="note">We sent a 6-digit code to <b>' +
            email.replace(/[&<>"']/g, function (c) {
              return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
            }) + '</b>. It is good for 15 minutes.</p>' +
            '<form class="redeem-form" data-member-form>' +
            '<input type="text" name="v" inputmode="numeric" autocomplete="one-time-code" ' +
            'placeholder="123456" required>' +
            '<button class="btn btn-primary" type="submit">Unlock</button></form>' +
            '<p class="note"><a href="#" data-member-back>Use a different email</a></p>';
        }
        if (API) {
          return '<p class="note">Enter your order number &mdash; it is at the top of your ' +
            'receipt from us, like <b>#1002</b>.</p>' +
            '<form class="redeem-form" data-member-form>' +
            '<input type="text" name="v" placeholder="#1002" autocomplete="off" required>' +
            '<button class="btn btn-primary" type="submit">Unlock</button></form>' +
            '<p class="note"><a href="#" data-member-back>Use a different email</a></p>';
        }
        return '<p class="note">Enter the access key from your welcome email.</p>' +
          '<form class="redeem-form" data-member-form>' +
          '<input type="text" name="v" placeholder="VAULT-XXXX-XXXX-XXXX" autocomplete="off" ' +
          'autocapitalize="characters" spellcheck="false" required>' +
          '<button class="btn btn-primary" type="submit">Unlock</button></form>';
      }

      function render() {
        mm.querySelector(".member-body").innerHTML = fields();
        var input = mm.querySelector("input");
        if (input) setTimeout(function () { input.focus(); }, 50);
      }

      function build() {
        if (mm) return mm;
        mm = document.createElement("div");
        mm.className = "modal key-modal";
        mm.innerHTML =
          '<div class="modal-inner"><button class="modal-close" type="button" aria-label="Close">&times;</button>' +
          '<div class="price-card"><div class="plan">Member sign-in</div>' +
          '<div class="member-body"></div>' +
          '<p class="note key-err" hidden style="color:#ff8f8f"></p>' +
          '<p class="note" style="margin-top:14px">Not a member yet? ' +
          '<a href="#pricing" data-action="buy">Unlock the vault &middot; $12/mo</a></p>' +
          '</div></div>';
        document.body.appendChild(mm);
        mm.addEventListener("click", function (e) { if (e.target === mm) close(); });
        mm.querySelector(".modal-close").addEventListener("click", close);
        mm.addEventListener("click", function (e) {
          if (e.target.closest("[data-member-back]")) {
            e.preventDefault(); step = "email"; err(""); render();
          }
        });
        mm.addEventListener("submit", function (e) {
          if (!e.target.closest("[data-member-form]")) return;
          e.preventDefault();
          submit(e.target);
        });
        render();
        return mm;
      }

      function err(msg) {
        var el = mm.querySelector(".key-err");
        el.textContent = msg || "";
        el.hidden = !msg;
      }

      function busy(form, on, label) {
        var b = form.querySelector("button");
        if (!b) return;
        b.disabled = on;
        if (on) { b.dataset.was = b.textContent; b.textContent = label || "Working…"; }
        else if (b.dataset.was) { b.textContent = b.dataset.was; }
      }

      function submit(form) {
        var value = String(form.querySelector("input").value || "").trim();
        if (!value) return;
        err("");
        busy(form, true);

        var done = function () { busy(form, false); };
        var oops = function (e) { done(); err(e.message || "Try again."); };

        if (!API) {
          legacyUnlock(value.toUpperCase())
            .then(function () {
              try { localStorage.setItem(LEGACY_KEY, value.toUpperCase()); } catch (e) {}
              close(); toast("Welcome back. Everything is unlocked.", true);
            })
            .catch(function () {
              done();
              err("That key isn’t valid. Check the email you got after subscribing.");
            });
          return;
        }

        if (step === "email") {
          email = value.toLowerCase();
          post("/auth/start", { email: email })
            .then(function (r) { done(); method = r.method || "order"; step = "second"; render(); })
            .catch(oops);
          return;
        }

        var payload = { email: email };
        payload[method === "code" ? "code" : "order"] = value;
        post("/auth/verify", payload)
          .then(function (r) {
            try { localStorage.setItem(TOKEN_KEY, r.token); } catch (e) {}
            return loadVault(r.token);
          })
          .then(function () { done(); close(); toast("Welcome back. Everything is unlocked.", true); })
          .catch(oops);
      }

      function open() {
        if (typeof closeUnlockSheet === "function") closeUnlockSheet();
        step = "email";
        build().classList.add("open");   // must exist before err()/render() touch it
        err("");
        render();
        document.body.style.overflow = "hidden";
      }
      function close() {
        if (mm) { mm.classList.remove("open"); document.body.style.overflow = ""; }
      }

      document.addEventListener("click", function (e) {
        if (e.target.closest("[data-key-open]")) { e.preventDefault(); open(); }
      });
      $$("a.nav-auth--login").forEach(function (a) {
        a.addEventListener("click", function (e) { e.preventDefault(); open(); });
      });

      /* ---------------- silent re-unlock on every visit ---------------- */
      if (CFG.isMember) return;             // Liquid already unlocked the page
      var token = null, legacy = null;
      try {
        token = localStorage.getItem(TOKEN_KEY);
        legacy = localStorage.getItem(LEGACY_KEY);
      } catch (e) {}

      if (API && token) {
        loadVault(token).catch(function () {
          /* expired, revoked, or the API moved - make them sign in again */
          try { localStorage.removeItem(TOKEN_KEY); localStorage.removeItem(KEY); } catch (e) {}
        });
      } else if (!API && legacy && MK) {
        legacyUnlock(legacy).catch(function () {});
      }
    })();

    function legacyCopy(text) {
      var ta = document.createElement("textarea");
      ta.value = text; ta.style.position = "fixed"; ta.style.opacity = "0";
      document.body.appendChild(ta); ta.select();
      try { document.execCommand("copy"); } catch (e) {}
      document.body.removeChild(ta);
    }

    /* lock veils open the modal - keyboard included, they are divs with
       role=button so Enter/Space must work like a click */
    $$("#grid .lock-veil").forEach(function (v) {
      v.addEventListener("click", function () { openModal(); });
      v.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") { e.preventDefault(); openModal(); }
      });
    });

    /* unlock / checkout buttons */
    $$("[data-action='unlock']").forEach(function (b) {
      b.addEventListener("click", function (e) { e.preventDefault(); openModal(); });
    });
    $$("[data-action='buy']").forEach(function (b) {
      b.addEventListener("click", buyOrSheet);
    });
    $$("[data-buy-form]").forEach(function (f) {
      f.addEventListener("submit", buyNow);
    });

    $$("[data-action='checkout']").forEach(function (b) {
      b.addEventListener("click", function (e) { e.preventDefault(); startCheckout(); });
    });
    $$("[data-action='close-modal']").forEach(function (b) {
      b.addEventListener("click", closeModal);
    });
    if (modal) {
      modal.addEventListener("click", function (e) { if (e.target === modal) closeModal(); });
    }
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeModal(); });

    /* Free access is granted only after Shopify confirms the customer form. */
    if(window.UNREEL_SIGNUP_CONFIRMED){
      try{localStorage.setItem(SIGNUP_KEY,JSON.stringify({confirmed:true}));}catch(_){}
      paint();toast(COPY.signup_success,true);
    }

    /* redeem forms (there are two: page + modal) */
    $$("[data-redeem-form]").forEach(function (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var input = form.querySelector("input");
        redeem(input.value, input);
      });
    });

    /* dev escape hatch: lock it again to check the paywall */
    $$("[data-action='relock']").forEach(function (b) {
      b.addEventListener("click", function (e) { e.preventDefault(); revoke(); });
    });

    /* Real clips, loaded lazily.

       Each card holds a 16:9 clip. Loading and playing all of them at once
       would mean ~90 simultaneous downloads and 90 decoding video elements,
       which stalls the page badly on a phone. Instead a clip only fetches and
       plays once it scrolls into view, and pauses when it leaves. */
    var videos = $$("video.card-video");

    /* iOS Safari holds every decoded clip in memory and will kill the tab
       ("A problem repeatedly occurred") long before 90 of them are loaded.
       So a clip is not merely paused when it scrolls away - its src is
       removed and the element reloaded, which frees the decoder and the
       buffered data. Only a handful are ever live at once. */
    // Phones stay capped hard (the original iOS crash), but a desktop grid
    // shows up to a dozen cards at once - a cap of 6 was evicting clips that
    // were still on screen, snapping them back to the placeholder scene.
    var MAX_LIVE = window.innerWidth > 900 ? 14 : (window.innerWidth > 600 ? 10 : 6);
    var live = [];                              // least-recent first

    /* WCAG 2.2.2: moving content that plays for more than 5s needs a way to
       pause it. motionOff is true when the OS asks for reduced motion OR the
       visitor flips the "Pause motion" toggle; activate() honours it, so no
       card clip ever autoplays against the user's wish. */
    var prefersReduce = window.matchMedia &&
        window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var motionOff = prefersReduce;
    try { if (localStorage.getItem("unreel_motion") === "off") motionOff = true;
          if (localStorage.getItem("unreel_motion") === "on")  motionOff = false; } catch (e) {}

    function showScene(v, on) {
      if (v.getAttribute("poster")) on = false;
      var p = v.parentNode;
      var scene = p.querySelector(".scene");
      var ov = p.querySelector(".ov");
      if (scene) scene.style.display = on ? "" : "none";
      if (ov) ov.style.display = on ? "" : "none";
    }

    function release(v) {
      var i = live.indexOf(v);
      if (i > -1) live.splice(i, 1);
      if (!v.getAttribute("src")) return;
      v.pause();
      v.removeAttribute("src");
      v.load();                                 // frees decoder + buffer
      showScene(v, true);                       // CSS scene takes over again
    }

    function activate(v) {
      // Reduced-motion / paused: still register as "live" and paint the first
      // frame, but never call play().
      if (motionOff) {
        if (!v.getAttribute("src")) {
          var s0 = v.getAttribute("data-src");
          if (s0) { v.setAttribute("src", s0); try { v.load(); } catch (e) {} }
        }
        return;
      }
      var i = live.indexOf(v);
      if (i > -1) live.splice(i, 1);
      live.push(v);
      while (live.length > MAX_LIVE) release(live[0]);

      if (!v.getAttribute("src")) {
        var src = v.getAttribute("data-src");
        if (!src) return;
        v.setAttribute("src", src);
      }
      // iOS only permits unattended playback when these are true at the
      // moment play() is called. Attributes alone are unreliable once src is
      // assigned from script, so set the properties too.
      v.muted = true;
      v.playsInline = true;
      var p = v.play();
      if (p && p.catch) p.catch(function () {
        // iOS refuses muted autoplay in Low Power Mode and when Settings >
        // Safari > Auto-Play is off. Never fall back to the fake CSS scene in
        // that case - the real first frame is the product. Force it to paint
        // and let a tap start playback.
        v.classList.add("needs-tap");
        if (v.readyState < 2) { try { v.load(); } catch (e) {} }
      });
    }

    /* Tap a clip to play it when autoplay was refused. Locked cards keep their
       existing behaviour - the veil opens the unlock modal instead. */
    document.addEventListener("click", function (e) {
      var w = e.target && e.target.closest ? e.target.closest(".media-wrap") : null;
      if (!w || w.querySelector(".lock-veil")) return;
      var v = w.querySelector("video.card-video");
      if (!v) return;
      if (v.paused) { activate(v); } else { v.pause(); }
    });

    videos.forEach(function (v) {
      v.addEventListener("error", function () {
        // load() on a released element fires error too - that one is ours.
        if (!v.getAttribute("src")) return;
        // A load aborted by backgrounding is not a broken file. Drop it and
        // allow one more attempt before falling back to the CSS scene, or a
        // single network blip would blank that card for the whole session.
        var tries = (parseInt(v.getAttribute("data-tries"), 10) || 0) + 1;
        v.setAttribute("data-tries", tries);
        release(v);
        if (tries >= 3) { if (!v.getAttribute("poster")) v.style.display = "none"; showScene(v, true); }
      });
      v.addEventListener("loadeddata", function () { showScene(v, false); });
    });

    if (videos.length && window.IntersectionObserver) {
      var vo = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = e.target.matches("video") ? e.target
                : e.target.querySelector("video.card-video");
          if (!v) return;
          if (e.isIntersecting) { activate(v); } else { release(v); }
        });
      }, { rootMargin: "100px 0px", threshold: 0.01 });
      // Observe the card, not the video. The card carries content-visibility,
      // so its own box is always laid out, while a skipped subtree's video
      // may not be. Same trigger, one less thing that can silently not fire.
      videos.forEach(function (v) { vo.observe(v.closest(".card") || v); });
    } else {
      videos.slice(0, MAX_LIVE).forEach(activate);   // no IO: load a few only
    }

    /* A backgrounded tab on iOS is a common moment to be evicted. Drop every
       clip when the page is hidden; the observer reloads what is on screen. */
    /* Everything on screen right now, reloaded. The observer only fires on a
       CHANGE in intersection, so after clips are dropped it never fires again
       for cards that were already visible - they would sit on the CSS scene
       forever. This is what re-arms them. */
    function reviveVisible() {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      videos.forEach(function (v) {
        var box = (v.closest(".card") || v).getBoundingClientRect();
        if (box.top < vh + 120 && box.bottom > -120) { activate(v); }
      });
    }

    document.addEventListener("visibilitychange", function () {
      if (document.hidden) { live.slice().forEach(release); }
      else { reviveVisible(); }
    });
    // Returning via the bfcache (back button, app switcher) does not always
    // fire visibilitychange, so cover that path too.
    window.addEventListener("pageshow", reviveVisible);
    window.addEventListener("focus", reviveVisible);

    /* "Pause motion" control (also the switch that enforces reduced-motion).
       Injected next to the result line so it sits with the other vault
       controls; persists the choice so it survives navigation. */
    (function () {
      if (!videos.length) return;
      var host = document.querySelector(".controls") || document.body;
      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "motion-toggle";
      function paintBtn() {
        btn.textContent = motionOff ? "\u25B6 Play motion" : "\u23F8 Pause motion";
        btn.setAttribute("aria-pressed", motionOff ? "true" : "false");
      }
      function applyMotion() {
        if (motionOff) { live.slice().forEach(function (v) { v.pause(); }); }
        else { reviveVisible(); }
        paintBtn();
      }
      btn.addEventListener("click", function () {
        motionOff = !motionOff;
        try { localStorage.setItem("unreel_motion", motionOff ? "off" : "on"); } catch (e) {}
        applyMotion();
      });
      paintBtn();
      host.appendChild(btn);
      // enforce the initial state (reduced-motion users start paused)
      if (motionOff) videos.forEach(function (v) { v.pause(); });
    })();
  });
})();

/* ============================================================
   Mobile menu — burger in the nav opens a slide-in drawer with
   every page link. The drawer is a dialog: focus moves in, Tab
   cycles inside it, Escape and the backdrop close it.
   ============================================================ */
(function () {
  "use strict";
  var burger = document.querySelector(".nav-burger");
  var menu = document.getElementById("mobile-menu");
  if (!burger || !menu) return;
  var panel = menu.querySelector(".mobile-menu-panel");
  var lastFocus = null;

  function focusables() {
    return Array.prototype.slice.call(
      panel.querySelectorAll("a[href], button:not([disabled])"));
  }

  function setOpen(open) {
    if (open) {
      lastFocus = document.activeElement;
      menu.hidden = false;
      /* force a layout so the slide-in transition runs from the closed state
         (rAF is avoided on purpose - it can stall in backgrounded views) */
      void menu.offsetHeight;
      menu.classList.add("open");
      burger.setAttribute("aria-expanded", "true");
      document.documentElement.classList.add("menu-locked");
      var f = focusables();
      if (f.length) f[0].focus();
    } else {
      menu.classList.remove("open");
      burger.setAttribute("aria-expanded", "false");
      document.documentElement.classList.remove("menu-locked");
      window.setTimeout(function () { menu.hidden = true; }, 240);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
  }

  burger.addEventListener("click", function () {
    setOpen(burger.getAttribute("aria-expanded") !== "true");
  });

  document.addEventListener("unreel:close-menu",function(){if(!menu.hidden)setOpen(false);});
  menu.addEventListener("click", function (e) {
    var t = e.target;
    while (t && t !== menu) {
      if (t.hasAttribute && (t.hasAttribute("data-menu-close") || t.tagName === "A")) {
        setOpen(false);
        return;
      }
      t = t.parentNode;
    }
  });

  menu.addEventListener("keydown", function (e) {
    if (e.key === "Escape") { setOpen(false); return; }
    if (e.key !== "Tab") return;
    var f = focusables();
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault(); last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault(); first.focus();
    }
  });
})();

/* ============================================================
   Pricing: monthly / annual toggle. Swaps the displayed price and
   the hidden variant + selling_plan on the buy form. Defaults to
   annual (set in the markup); this only reacts to clicks.
   ============================================================ */
(function () {
  "use strict";
  var toggle = document.querySelector(".plan-toggle");
  if (!toggle) return;
  var amt = document.getElementById("price-amt"),
      per = document.getElementById("price-per"),
      sub = document.getElementById("price-sub"),
      fine = document.getElementById("price-fine"),
      buyId = document.getElementById("buy-id"),
      buyPlan = document.getElementById("buy-plan");
  var REFUND = ' — see our <a href="/policies/refund-policy">refund policy</a>.';
  var opts = Array.prototype.slice.call(toggle.querySelectorAll(".pt-opt"));
  opts.forEach(function (opt) {
    opt.addEventListener("click", function () {
      opts.forEach(function (o) { o.classList.remove("is-on"); o.setAttribute("aria-selected", "false"); });
      opt.classList.add("is-on"); opt.setAttribute("aria-selected", "true");
      var d = opt.dataset;
      if (amt) amt.textContent = d.amt;
      if (per) per.textContent = d.per;
      if (sub) sub.innerHTML = d.sub;
      if (fine) fine.innerHTML = d.fine.replace(/\.$/, "") + REFUND;
      if (buyId) buyId.value = d.variant;
      if (buyPlan) buyPlan.value = d.plan;
    });
  });
})();

/* ============================================================
   First-party analytics — privacy-first, no third-party trackers.
   Captures the events the business actually needs (activation,
   copies, builds, the Higgsfield affiliate click-through, signups,
   category interest, return visits) via delegated listeners, keeps
   a per-device rollup in localStorage, and beacons each event to
   YOUR OWN collector only if one is configured (theme setting
   "Analytics endpoint" -> CFG.analyticsUrl). Blank endpoint = the
   data never leaves the device. Nothing is sent to any third party.
   ============================================================ */
(function () {
  "use strict";
  var CFG = window.UNREEL_CONFIG || {};
  var ENDPOINT = (CFG.analyticsUrl || "").trim();
  var SKEY = "unreel_stats";
  function day() { return new Date().toISOString().slice(0, 10); }
  function load() {
    try {
      var s = JSON.parse(localStorage.getItem(SKEY) || "null");
      if (s && s.days) return s;
    } catch (e) {}
    return { first: day(), last: null, days: {}, copies: 0, builds: 0, mv: 0, signups: 0, activated: 0 };
  }
  function save(s) { try { localStorage.setItem(SKEY, JSON.stringify(s)); } catch (e) {} }

  function beacon(event, props) {
    if (!ENDPOINT) return;              // privacy-first: only your own collector, never a third party
    try {
      var body = JSON.stringify({
        e: event, t: Date.now(),
        member: CFG.isMember === true ? 1 : 0,
        path: location.pathname, p: props || {}
      });
      if (navigator.sendBeacon) {
        /* text/plain is CORS-safelisted, so the beacon needs no preflight it
           cannot do; the Worker parses the JSON body itself. */
        navigator.sendBeacon(ENDPOINT, new Blob([body], { type: "text/plain" }));
      } else {
        fetch(ENDPOINT, { method: "POST", body: body, keepalive: true, mode: "cors",
          headers: { "Content-Type": "text/plain" } });
      }
    } catch (e) {}
  }

  function track(event, props) {
    var s = load();
    s.last = day(); s.days[day()] = (s.days[day()] || 0) + 1;
    if (event === "copy_prompt") s.copies++;
    else if (event === "builder_generate") s.builds++;
    else if (event === "make_video") s.mv++;
    else if (event === "signup") s.signups++;
    if ((event === "copy_prompt" || event === "builder_generate") && !s.activated) {
      s.activated = 1; beacon("activation", {});
    }
    save(s);
    beacon(event, props);
  }
  window.unreelTrack = track;   // so builder.js (or anything) can add events

  /* page view + returning-visitor flag (a real return = a day gap) */
  var prior = load();
  track("page_view", { returning: (prior.last && prior.last !== day()) ? 1 : 0 });

  /* everything else via delegation — no edits to other handlers */
  document.addEventListener("click", function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest(".video-link, #make-video, [data-video-prompt]")) {
      track("make_video", { from: t.closest("#make-video") ? "builder" : "card" });
    } else if (t.closest("[data-copy-from-pre], #copy")) {
      track("copy_prompt", {});
    } else if (t.closest("#generate")) {
      track("builder_generate", {});
    } else if (t.closest(".filters button")) {
      var b = t.closest(".filters button");
      track("filter", { cat: b.getAttribute("data-filter") || "" });
    }
  }, true);

  document.addEventListener("submit", function (e) {
    if (e.target && e.target.closest && e.target.closest("[data-signup-form]")) track("signup", {});
  }, true);
})();



